Drupal.behaviors.externalLinkSpeedbump = {
  attach: function (context, settings) {
    const currentUrl = window.location.pathname;
    alertify.defaults.transitionOff = true;
    alertify.defaults.movable = false;

    const allLinks = context.querySelectorAll("a[href]");
    const siteOrigin = window.location.origin;

    const externalLinks = Array.from(allLinks).filter((link) => {
      // Ignore anchor, javascript, email, tel, and whitelisted links
      const href = link.getAttribute("href");
      if (
        currentUrl.startsWith("/going-local") ||
        !href ||
        href.startsWith("mailto:") ||
        href.startsWith("tel:") ||
        href.startsWith("#") ||
        href.startsWith("javascript:") ||
        href.includes("fivision.com") ||
        href.includes("civicfcu.org") ||
        href.includes("civicimpacts.org") ||
        href.includes("civicfoundationnc.org") ||
        href.includes("apps.rps.ascensus.com") ||
        href.includes("deluxebillpay.com/ebpp/CivicCU") ||
        href.startsWith("/")
      ) {
        return false;
      }
      // Create a URL object to compare origins
      try {
        const url = new URL(href, siteOrigin);
        return url.origin !== siteOrigin;
      } catch (e) {
        // If URL constructor fails, treat as internal
        return false;
      }
    });
    externalLinks.forEach(function (link) {
      link.addEventListener("click", function (event) {
        const targetHref = event.currentTarget.getAttribute("href");
        const exitMessageID =
          event.currentTarget.getAttribute("data-exit_messages");
        const ID = parseInt(exitMessageID);
        let link_message;

        if (ID > 0 && drupalSettings.exit_messages.messages[ID]) {
          link_message = drupalSettings.exit_messages.messages[ID].message;
        }

        event.preventDefault();

        let message =
          "<h3>You're leaving the Civic FCU website.</h3><p>Civic does not operate the site you are about to visit and is not responsible for the content or any transactions performed on a non-Civic website.</p><p>Also note that the privacy and security policies may differ from those practiced by Civic.</p>";

        if (link_message) {
          message = link_message;
        }

        alertify
          .confirm(
            "Leaving Civic's Website",
            message,
            function () {
              window.open(targetHref, "_blank");
            },
            function () {}
          )
          .set("reverseButtons", true);

        setTimeout(function () {
          document
            .querySelector(".ajs-proceed")
            .setAttribute("aria-label", "Proceed");
          document
            .querySelector(".ajs-cancel")
            .setAttribute("aria-label", "Cancel");
        });
      });
    });
  },
};
